// format.js — Formatting utilities

export function formatAmount(amount, currency = 'USD', compact = false) {
  if (amount == null || isNaN(amount)) return '—';
  const absAmount = Math.abs(amount);

  const opts = {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  };

  if (compact && absAmount >= 1_000_000) {
    return new Intl.NumberFormat('en-US', { ...opts, notation: 'compact', compactDisplay: 'short' }).format(amount);
  }
  if (compact && absAmount >= 100_000) {
    return new Intl.NumberFormat('en-US', { ...opts, notation: 'compact', compactDisplay: 'short' }).format(amount);
  }

  try {
    return new Intl.NumberFormat('en-US', opts).format(amount);
  } catch {
    return `${amount.toFixed(0)}`;
  }
}

export function formatAmountFull(amount, currency = 'USD') {
  if (amount == null || isNaN(amount)) return '—';
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)}`;
  }
}

export function formatPercent(value, decimals = 1) {
  if (value == null || isNaN(value)) return '—';
  return `${value.toFixed(decimals)}%`;
}

export function formatSalaryInput(raw) {
  // Remove non-numeric except decimal
  const cleaned = String(raw).replace(/[^\d.]/g, '');
  const parts = cleaned.split('.');
  const integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.length > 1 ? `${integer}.${parts[1]}` : integer;
}

export function parseSalaryInput(raw) {
  const cleaned = String(raw).replace(/[^\d.]/g, '');
  const val = parseFloat(cleaned);
  return isNaN(val) ? 0 : val;
}

export function abbreviateNumber(n) {
  if (!n) return '0';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)}K`;
  return `${Math.round(n)}`;
}